<div class="container-fluid mt-4">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">
        Licences
        <button type="button" class="btn btn-primary btn-sm" (click)="create()">
          <fa-icon [icon]="['fal', 'plus']"></fa-icon> Create Shopify Licence
        </button>
      </h3>
      <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="shopping-basket" size="lg" [fixedWidth]="true"> </fa-icon>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead class="text-primary">
            <tr>
              <th>Product</th>
              <th>Pattern</th>
              <th>Usage</th>
              <th>Volume</th>
              <th>Roles</th>
              <th>Duration</th>
              <th class="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let licence of licences">
              <td *ngIf="!!licence.item">{{ licence.item.title }}</td>
              <td *ngIf="!licence.item" class="text-warning">
                <span ngbTooltip="This product does no longer exist in shopify" placement="right"> {{ licence.product }} </span>
              </td>
              <td>{{ licence.pattern }}</td>
              <td>{{ licence.usage }}</td>
              <td>{{ licence.volume }}</td>
              <td>{{ licence.profile.meta.roles.join(', ') }}</td>
              <td>{{ duration.formatIso(licence.profile.meta.duration) }}</td>
              <td class="text-right nowrap">
                <button type="button" [disabled]="!canEdit" class="btn btn-light me-1 btn-sm" ngbTooltip="Edit" (click)="update(licence)">
                  <fa-icon [fixedWidth]="true" [icon]="['fal','cog']"></fa-icon>
                </button>
                <button
                  type="button"
                  [disabled]="!canEdit || !licence.item"
                  class="btn btn-primary me-1 btn-sm"
                  ngbTooltip="Purchase a licence"
                  (click)="purchase(licence)"
                >
                  <fa-icon [fixedWidth]="true" [icon]="['fal','shopping-cart']"></fa-icon>
                </button>
                <button
                  type="button"
                  [disabled]="!canDelete"
                  class="btn btn-danger me-1 btn-sm"
                  ngbTooltip="Delete"
                  (click)="deleteSwalOptions(licence)"
                >
                  <fa-icon [fixedWidth]="true" [icon]="['fal','trash']"></fa-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="card mt-4" *ngIf="orders">
    <div class="card-header">
      <h3 class="card-title">Purchases</h3>
      <fa-icon class="card-header-icon bg-gradient-primary text-white" icon="shopping-cart" size="lg" [fixedWidth]="true"> </fa-icon>
    </div>
    <div class="card-body">
      <div class="table-responsive">
        <table class="table table-hover">
          <thead class="text-primary">
            <tr>
              <th>Product</th>
              <th>Licence Key</th>
              <th>Customer</th>
              <th>Mail</th>
              <th>Timestamp</th>
              <th class="text-right">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let order of orders">
              <td>{{ order.title }}</td>
              <td>{{ order.licenceKey }}</td>
              <td>{{ order.firstName }} {{ order.lastName }}</td>
              <td>{{ order.mail }}</td>
              <td>{{ order.timestamp | date:dateTimeFormat }}</td>
              <td class="text-right nowrap">
                <button
                  type="button"
                  [disabled]="!canEdit"
                  class="btn btn-primary me-1 btn-sm"
                  ngbTooltip="Edit and send mail again"
                  (click)="resend(order)"
                >
                  <fa-icon [fixedWidth]="true" [icon]="['fal','envelope']"></fa-icon>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
